"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _LineRestrictionApi_lineRestriction;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineRestrictionApi = void 0;
const AbstractRestrictionApi_1 = require("../AbstractRestrictionApi");
class LineRestrictionApi extends AbstractRestrictionApi_1.AbstractRestrictionApi {
    // #endregion Properties (1)
    // #region Constructors (1)
    constructor(restriction) {
        super(restriction);
        // #region Properties (1)
        _LineRestrictionApi_lineRestriction.set(this, void 0);
        __classPrivateFieldSet(this, _LineRestrictionApi_lineRestriction, restriction, "f");
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (3)
    get point1() {
        return __classPrivateFieldGet(this, _LineRestrictionApi_lineRestriction, "f").point1;
    }
    get point2() {
        return __classPrivateFieldGet(this, _LineRestrictionApi_lineRestriction, "f").point2;
    }
    get radius() {
        return __classPrivateFieldGet(this, _LineRestrictionApi_lineRestriction, "f").radius;
    }
}
exports.LineRestrictionApi = LineRestrictionApi;
_LineRestrictionApi_lineRestriction = new WeakMap();
//# sourceMappingURL=LineRestrictionApi.js.map